/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { UnitPageComponent } from "@src/app/modules/unit/unit-page/unit-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const UnitPageNavRoute = new NavRoute('units', ()=>UnitPageComponent, 'home_work').setViews(() => {
        return [
            {
                id: 'allUnits',
                name: 'All Units',
                helpText: 'All units in the development',
                filterFields: {
                    typeId: 'All',
                    areaId: 'All',
                    name: null,
                    keyword: null,
                },
            },
            {
                id: 'missingDetails',
                name: 'Missing Owner Details',
                helpText: 'Units where owner contact details are missing',
                filterFields: {
                    typeId: 'All',
                    areaId: 'All',
                    name: null,
                    missingDetails: 1,
                },
            }
        ];
    });
